interface Props {
    read?: boolean;
}

export default function StatusCheck(props: Props) {
    const { read = false } = props;

    const fill = read ? '#4A52BB' : '#282828';

    return (
        <svg
            id="StatusCheck"
            width="12"
            height="9"
            viewBox="0 0 12 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.68344 0.854743L4.48692 6.05153L2.31656 3.88106C1.84327 3.40774 1.07826 3.40774 0.604968 3.88106C0.131677 4.35437 0.131677 5.11943 0.604968 5.59274L3.63112 8.61906C3.86716 8.85511 4.17704 8.97374 4.48692 8.97374C4.7968 8.97374 5.10668 8.85511 5.34272 8.61906L11.395 2.56643C11.8683 2.09311 11.8683 1.32806 11.395 0.854743C10.9217 0.381427 10.1567 0.381427 9.68344 0.854743Z"
                fill={fill}
            />
        </svg>
    );
}
